export const allTrue = (prev, curr) => prev && curr;

export const anyTrue = (prev, curr) => prev || curr;

export const concat = (prev, curr) => prev.concat(curr);

export const sum = (prev, curr) => prev + curr;
